import { Plugins } from "./system/Plugins.js";
import { AjaxClick } from "./utils/AjaxClick.js";

export class Frontend {

    constructor() {
        console.log("[eventfive.wordpress-plugin]", "[Frontend]");

        new Plugins();
        new AjaxClick();

        // e5.Plugins.playerSync.registerConsumer({
        //     guid: "d8lnxi",
        //     kind: "lottie",
        //     onProgress: (player, progress) => {
        //         console.log("Progress", progress);
        //     }
        // });
    }
}

e5.ready(() => {
    new Frontend();
});